<template lang="">
  <div class="bottom-0 left-0 container-footer w-full">
    <div class="container">
      <ul
        class="flex flex-wrap justify-content-start align-items-center h-full text-white m-0"
      >
        <a
          href="https://www.anfr.fr/accueil"
          target="_blank"
        >
          {{ $t("footer.home") }}
        </a>
        <li class="cursor-pointer text-white">
          <router-link to="/legacyNotice">
            {{ $t("footer.mentionLegal") }}
          </router-link>
        </li>
        <li class="cursor-pointer text-white">
          <router-link to="/cgu">
            {{ $t("footer.cgu") }}
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss" scoped>
a {
  color: white;
  text-decoration: none;
  font-weight: normal;

  p {
    padding: 0 20px;
  }
}

.container-footer {
  background-color: #282828;

  ul {
    min-height: 55px;
    list-style: none;

    li {
      padding: 20px;
    }
  }
}
</style>
